module.exports = __webpack_public_path__ + "img/prove6.00ecd8bc.png";